import { rcLogger } from './logger';

export const timeCall =
  (taskName: string) =>
  async <R>(executor: (...params: any[]) => Promise<R>) => {
    const start = performance.now();
    rcLogger.debug(`Timed Task: '${taskName}' starting.`);
    const result = await executor();
    const end = performance.now();
    rcLogger.debug(
      `Timed Task: '${taskName}' finished. Took ${Math.ceil(end - start)} ms`
    );

    return result;
  };
